

export class UserTypeOutputWithStatus implements IUserTypeOutputWithStatus {
    /** The auto-generated id of the user type master */
    user_type_id!: number;
    /** The user type code with 255 character limit */
    user_type_code!: string;
    /** The user type code with 255 character limit */
    user_type_name!: string;
    /** Manage status of user type. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IUserTypeOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_type_id = _data["user_type_id"];
            this.user_type_code = _data["user_type_code"];
            this.user_type_name = _data["user_type_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserTypeOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_type_id"] = this.user_type_id;
        data["user_type_code"] = this.user_type_code;
        data["user_type_name"] = this.user_type_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IUserTypeOutputWithStatus {
    /** The auto-generated id of the user type master */
    user_type_id: number;
    /** The user type code with 255 character limit */
    user_type_code: string;
    /** The user type code with 255 character limit */
    user_type_name: string;
    /** Manage status of user type. 0 For De-active, 1 For Active */
    status: number;
}

